<template>
  <v-container>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout>
        <v-flex xs12 sm4 offset-sm1>
          <v-select
                  :items="$store.state.companies"
                  v-model="activity.company"
                  label="Compañia"
                  item-value="id"
                  item-text="name"
                  :rules="[v => !!v || 'Campo requerido']"
                  return-object
                  persistent-hint
                  required
                  @change="changeCompany"
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm4 offset-sm1>
          <v-text-field
              name="periodo"
              label="Período"
              id="periodo"
              :rules="[v => !!v || 'Campo requerido']"
              readonly
              v-model="activityPeriod.name"
              required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm4 offset-sm1>
          <v-autocomplete
                  :items="this.activitiesConfig"
                  v-model="activity.activityConfigurationCompany"
                  label="Actividad"
                  item-value="id"
                  item-text="codeName"
                  :rules="[v => !!v || 'Campo requerido']"
                  return-object
                  persistent-hint
                  required
          >
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm7 offset-sm1>
          <v-text-field
                  name="anfitrion"
                  label="Nombre / Objetivo"
                  id="anfitrion"
                  :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 250) || 'El código debe tener menos de 250 caracteres']"
                  required
                  v-model="activity.name"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm10 offset-sm1>
          <v-textarea
                  name="nota"
                  label="Descripción"
                  id="nota"
                  :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 500) || 'El número de caracteres debe ser menor a 500']"
                  v-model="activity.description"
                  required
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm6 offset-sm4>
          <div>
            <v-btn :disabled="!valid"
                   @click="saveData" large color="primary">Guardar</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog
            v-model="dialogSuccess"
            max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>Se guardó con exito la información</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
                  color="primary"
                  text
                  @click="dialogSuccess = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>

import Activity from "../../model/Activity";

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Tipo', value: 'type' },
        { text: 'Nombre', value: 'name' },
        { text: 'ID', value: 'id' },
        { text: 'Código', value: 'code' },
        { text: 'Catálogo Padre', value: 'catalogueItemId' },
        { text: 'Estado', value: 'estado' },
        { text: 'Acciones', value: 'editar' },
      ],
      items: ['TIPO_DOCUMENTO'],
      editedIndex: -1,
      activity: new Activity(),
      dialogError: false,
      dialogSuccess: false,
      activitiesConfig:[],
      activityPeriod:""
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.activity = new Activity();
      this.valid = false;
      this.dialog = false;
    },
    newActivity() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.activity = new Activity();
    },
    saveData() {
      if (this.$refs.form.validate()) {
        this.activity.status = "CREADO"
        this.activity.date = new Date()
        this.activity.timesRejected = 0
        this.activity.activityConfigurationCompany = {id:this.activity.activityConfigurationCompany.id}
        this.activity.activityCompanyPeriod = {id:this.activityPeriod.id}
        this.activity.comments = []
        this.activity.comments.push({comment:'Se ha creado la actividad.', date:new Date(), user:{id:this.$store.state.userInSession.id, identification:this.$store.state.userInSession.identification, firstName:this.$store.state.userInSession.firstName, lastName:this.$store.state.userInSession.lastName}})
        this.activity.comments = this.activity.comments!=''?JSON.stringify(this.activity.comments): ''
        if (this.editedIndex > -1) {
          this.$store.dispatch('updateActivity', this.activity).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        } else {
          this.$store.dispatch('addActivity', this.activity).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        }
        this.activity = new Activity();
        this.dialogSuccess = true;
      }
    },
    changeCompany(){
      this.$store.dispatch('getActivityConfigurationCompanyAreEnable', this.activity.company.id).then(response => {
        this.$store.dispatch('getCompanyPeriodByCompany',this.activity.company.id).then(
            responsePeriod => {
              for (const period of responsePeriod.data) {
                if(period.status == 'ACTIVO'){
                  this.activityPeriod = period
                }
              }
            },
            error => {
              this.$store.state.dialogError = true;
            }
        );

        for (const data of response.data) {
          if(data.months!=null && data.months!= ''){
            data.months = JSON.parse(data.months)
          }
          if(data.questions!=null && data.questions!= ''){
            data.questions = JSON.parse(data.questions)
          }
          if(data.trimester!=null && data.trimester!= ''){
            data.trimester = JSON.parse(data.trimester)
          }
          data.codeName = data.code+" - "+data.name
          data.children = []
          if(data.frequency != '' && data.frequency != null){
            this.activitiesConfig.push(data)
          }
        }
      }, error => {
        this.$store.state.dialogError = true
      })
    }

  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getCompanies').then(response => {
      this.cleanData()
    }, error => {
      this.$store.state.dialogError = true
    })
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/activity/Activity.vue